import { Controller } from "@hotwired/stimulus"
import Accordion from "./accordion"

export default class extends Controller {
    static targets = ["element", "expand"]

    connect() {
        this.elementTargets.forEach(el => {
            const expandEl = this.expandTargets.find(ex => ex.parentNode === el)
            new Accordion(el, expandEl)
        })
    }

    openToggled(event) {
        if (!event.target.open) {
            event.target.classList.replace('border-gray-300', 'border-gray-100')
            return;
        }

        event.target.classList.replace('border-gray-100', 'border-gray-300')
        this.elementTargets.forEach(el => {
            if (!(el !== event.target && el.open)) return;
            el.classList.replace('border-gray-300', 'border-gray-100')
            el.querySelector('summary').dispatchEvent(new MouseEvent("click", {
                "view": window,
                "bubbles": true,
                "cancelable": false
            }))
        })

        const id = event.target.getAttribute('id');

        if (id) {
            setTimeout(() => {
                const loc = document.location.toString().split('#')[0];
                document.location = loc + '#' + id;
            }, 300);
        }
    }
}